import React, { useEffect, useState } from 'react';
import Authenticated from '@/Layouts/Authenticated';
import { Head, useForm } from '@inertiajs/inertia-react';
import Label from '@/Components/Label';
import Input from '@/Components/Input';
import Button from '@/Components/Button';
import rut from '@/helpers/rut';
import _ from 'lodash';
import Card from '@/Components/BulkSale/Create/Card';
import Select from '@/Components/Select';
import date from '@/helpers/date';

const Create = ({ store, scheduleTypesDurations, ...props }) => {
    const [errors, setErrors] = useState({});

    const { data, setData, processing, post } = useForm((props.flash?.form?.old && ({
        ...props.flash.form.old,

        'ticket_quantity': parseInt(props.flash.form.old?.ticket_quantity),
        'ticket_price': parseInt(props.flash.form.old?.ticket_price),
        'total_price': parseInt(props.flash.form.old?.total_price),
    })) || {
        'company_name': '',
        'rut': '',
        'contact_full_name': '',
        'email': '',
        'telephone': '',
        'schedule_type_duration': null,
        'payment_mode': 'transfer',
        'ticket_quantity': 0,
        'ticket_price': 0,
        'total_price': 0,
        'expiration': date.toString(date.addMonths(3, date.setHours(new Date()))),
        'is_weekend': false
    });

    const getFormErrors = (data) => {
        const emailRegexValidation = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        let errors = {
            hasErrors: false,
        };

        const addError = (field, errorMessage) => {
            const fieldErrors = [];

            if (errors[field]) {
                fieldErrors.push(...errors[field], errorMessage)
            } else {
                fieldErrors.push(errorMessage)
            }

            errors = {
                ...errors,
                [field]: fieldErrors,
                hasErrors: true
            }
        }

        if (!data.company_name) {
            addError("company_name", "El nombre de la empresa es requerido")
        }

        if (!data.rut) {
            addError("rut", "El R.U.T de la empresa es requerido")
        } else {
            if (!rut.validate(data.rut)) {
                addError("rut", "El R.U.T de la empresa no tiene el formato correcto")
            }
        }

        if (!data.contact_full_name) {
            addError("contact_full_name", "El nombre del contacto empresa es requerido")
        }

        if (!data.telephone) {
            addError("telephone", "El número de teléfono de la empresa es requerido")
        }

        if (!data.email) {
            addError("email", "El correo electrónico de la empresa es requerido")
        } else {
            if (!emailRegexValidation.test(data.email)) {
                addError("email", "El correo electrónico de la empresa no tiene el formato correcto")
            }
        }


        if (!(data.ticket_quantity > 0)) {
            addError("ticket_quantity", "La cantidad de tickets debe ser mayor que 0")
        }

        return errors;
    }

    const cleanError = (field) => {
        const formErrors = getFormErrors(data);

        if (formErrors[field]) {
            setErrors({...errors, [field]: formErrors[field], hasErrors: true});
        } else {
            const errorsFiltered = _.has(errors, field) ? _.omit(errors, field) : errors;
            setErrors({...errorsFiltered, hasErrors: formErrors.hasErrors});
        }
    }

    const onHandleChange = (event) => {
        const name = event.target.name;
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.type === "number" ? Number(event.target.value) : event.target.value;

        setData(name, value);
    };

    const onHandleChangeTicketQuantity = (event) => {
        const quantity = Number(event.target.value);

        setData({
            ...data,
            ticket_quantity: quantity,
        });
    };

    const submit = (event) => {
        event.preventDefault();
        const errors = getFormErrors(data);
        setErrors(errors);
        if (!errors.hasErrors) {
            post(route('bulk-sales.store'));
        }
    }

    const handleDownloadQuotation = () => {
        const errors = getFormErrors(data);
        setErrors(errors);
        if (!errors.hasErrors) {
            window.open(route('bulk-sales.quotation', data));
        }
    }

    useEffect(() => {
        const tickets_total_price = data.ticket_quantity * data.ticket_price;

        const total = tickets_total_price;

        setData('total_price', total)
    }, [data.ticket_quantity, data.ticket_price])

    return (
        <Authenticated
            store={store}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Ventas empresa</h2>}
        >
            <Head title="Ventas empresa" />

            <div className="py-8 max-w-7xl mx-auto">
                <div className="grid grid-cols-3 gap-6 px-6">
                    <form onSubmit={submit} className="bg-white p-8 mr-2 rounded-xl col-span-3 lg:col-span-2">
                        <div className="grid grid-cols-4 gap-x-4 gap-y-4 mb-4">
                            <div className="col-span-4 xs:col-span-2">
                                <Label forInput="company_name" value="Razón social" />
                                <Input
                                    maxLength={25}
                                    type="text"
                                    name="company_name"
                                    value={data.company_name}
                                    className="mt-1 block w-full"
                                    required={true}
                                    handleChange={onHandleChange}
                                    handleBlur={() => cleanError('company_name')}
                                    errors={errors?.company_name}
                                />
                            </div>
                            <div className="col-span-4 xs:col-span-2">
                                <Label forInput="rut" value="R.U.T" />
                                <Input
                                    type="text"
                                    name="rut"
                                    value={data.rut}
                                    className="mt-1 block w-full"
                                    required={true}
                                    handleChange={(event) => setData('rut', rut.format(event.target.value))}
                                    handleBlur={() => cleanError('rut')}
                                    errors={errors?.rut}
                                />
                            </div>
                            <div className="col-span-4">
                                <Label forInput="contact_full_name" value="Nombre y apellido del contacto empresa" />
                                <Input
                                    type="text"
                                    name="contact_full_name"
                                    value={data.contact_full_name}
                                    className="mt-1 block w-full"
                                    required={true}
                                    handleChange={onHandleChange}
                                    handleBlur={() => cleanError('contact_full_name')}
                                    errors={errors?.contact_full_name}
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4 mb-4">
                            <div>
                                <Label forInput="email" value="Correo electrónico" />
                                <Input
                                    type="text"
                                    name="email"
                                    value={data.email}
                                    className="mt-1 block w-full"
                                    required={true}
                                    handleChange={onHandleChange}
                                    handleBlur={() => cleanError('email')}
                                    errors={errors?.email}
                                />
                            </div>
                            <div>
                                <Label forInput="telephone" value="Número de teléfono" />
                                <Input
                                    type="text"
                                    name="telephone"
                                    value={data.telephone}
                                    className="mt-1 block w-full"
                                    required={true}
                                    handleChange={onHandleChange}
                                    handleBlur={() => cleanError('telephone')}
                                    errors={errors?.telephone}
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 xs:grid-cols-2 gap-x-4 gap-y-4 mb-4">
                            <div>
                                <Label forInput="ticket_quantity" value="Cantidad de tickets" />
                                <Input
                                    maxLength={5}
                                    exclude={['e', '-', '+', '.', ',']}
                                    min={0}
                                    type="number"
                                    name="ticket_quantity"
                                    value={data.ticket_quantity.toString()}
                                    className="mt-1 block w-full"
                                    required={true}
                                    handleChange={onHandleChangeTicketQuantity}
                                    errors={errors?.ticket_quantity}
                                    handleBlur={() => cleanError('ticket_quantity')}
                                />
                            </div>
                            <div>
                                <Label forInput="ticket_price" value="Precio por ticket" />
                                <Input
                                    maxLength={10}
                                    exclude={['e', '-', '+', '.', ',']}
                                    min={0}
                                    type="number"
                                    name="ticket_price"
                                    value={data.ticket_price.toString()}
                                    className="mt-1 block w-full"
                                    required={true}
                                    handleChange={onHandleChange}
                                />
                            </div>
                        </div>
{/* 
                        <div className="inline-flex items-center gap-2 mb-4">
                            <Checkbox
                                name="has_socks"
                                value={data.has_socks}
                                handleChange={onHandleChange}
                            />
                            <Label forInput="has_socks" value="Calcetines incluidos (Par de calcetines x Ticket)" />
                        </div> */}

                        <div className="mb-4">
                            <h3>Periodo de agendamiento</h3>

                            <div>
                                <div>
                                <Select
                                    options={scheduleTypesDurations.map((duration) => ({
                                        label: `${duration} ${duration === 1 ? 'hora' : 'horas'}`,
                                        value: duration
                                    }))}
                                    placeholder="Seleccione un periodo"
                                    onChange={({ value }) => setData('schedule_type_duration', value)}
                                />
                                {/* <pre><code>{JSON.stringify(scheduleTypesDurations, null, 4)}</code></pre> */}
                                </div>
                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="flex items-center gap-4">
                                <div>
                                    <Label forInput="input_expiration_date" value="Fecha de expiración" />
                                    <Input
                                        id="input_expiration_date"
                                        name="expiration"
                                        type="date"
                                        value={data.expiration}
                                        min={date.toString(date.addDays(1, date.setHours(new Date())))}
                                        handleChange={onHandleChange}
                                    />
                                {/* <pre><code>{JSON.stringify(scheduleTypesDurations, null, 4)}</code></pre> */}
                                </div>
                                <div className="flex items-center gap-2 pt-4">
                                    <Input
                                        id="input_is_weekend"
                                        name="is_weekend"
                                        type="checkbox"
                                        checked={data.is_weekend}
                                        handleChange={onHandleChange}
                                    />
                                    <Label forInput="input_is_weekend" value="Tickets de fin de semana" />
                                {/* <pre><code>{JSON.stringify(scheduleTypesDurations, null, 4)}</code></pre> */}
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-x-4 gap-y-4 flex-wrap">
                            <div className="flex items-center">
                                <input
                                    id="transfer_payment"
                                    type="radio"
                                    name="payment_mode"
                                    value="transfer"
                                    className="mr-1"
                                    required={true}
                                    checked={data.payment_mode === "transfer"}
                                    onChange={onHandleChange}
                                />
                                <Label forInput="transfer_payment" value="Pago por transferencia" />
                            </div>
                            <div className="flex items-center">
                                <input
                                    id="cash_payment"
                                    type="radio"
                                    name="payment_mode"
                                    value="cash"
                                    className="mr-1"
                                    required={true}
                                    checked={data.payment_mode === "cash"}
                                    onChange={onHandleChange}
                                />
                                <Label forInput="cash_payment" value="Pago en efectivo" />
                            </div>
                        </div>

                        <div className="flex items-center justify-center w-full mt-8 gap-4">
                            <Button processing={processing}>
                                Crear compra empresa
                            </Button>
                            <Button onClick={handleDownloadQuotation} type="button">
                                Crear cotización
                            </Button>
                        </div>
                    </form>
                    <Card {...data} />
                </div>
            </div>
        </Authenticated>
    )
};

export default Create;